













































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Error403 extends Vue {
  $router: any;

  goHome(): void {
    this.$router.push('/home');
  }

  goBack(): void {
    // this.$router.go(-1);
  }
}
